module.exports = __webpack_public_path__ + "img/drop-up-blue.c4e36381.svg";